<template>
  <section class="contact-area pb-90">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-box">
            <h3 class="title">基本资料</h3>
            
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              
              <el-row>
                <el-col :span="8">
                  <el-form-item label="姓名" prop="realname">
                    <el-input v-model="ruleForm.realname"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="7">
                  <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="ruleForm.gender">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="生日" prop="birthday">
                    <el-date-picker v-model="ruleForm.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="手机号" prop="cellphone">
                    <el-input v-model="ruleForm.cellphone"></el-input>
                  </el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="邮箱" prop="email">
                    <el-input v-model="ruleForm.email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="学校" prop="company">
                    <el-input v-model="ruleForm.company"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="院系" prop="department">
                    <el-input v-model="ruleForm.department"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="职务" prop="position">
                    <el-input v-model="ruleForm.position"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="职称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="研究方向" prop="summary">
                    <el-input type="textarea" :rows="3" v-model="ruleForm.summary"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { putProfile } from '@/api/user';
import { 
  formatTimestampToDate,
  formatDateToTimestamp 
} from '@/utils/dateUtil';
import jsQR from 'jsqr';
export default {
  props: {
    profile: {
      type: Object,
      default: () => ({}) // 接收父组件传递的 profile 数据
    }
  },
  components: {},
  data() {
    return {
      ruleForm: {
        realname: '', // 姓名
        gender: 1,   // 性别
        birthday: '', // 生日
        cellphone: '',// 手机号
        company: '',  // 公司
        position: '', // 职务
        email: '',    // 邮箱
        summary: '',
        wxqrcode: ''
      },
      rules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, message: '请输入姓名', trigger: 'blur' }
        ],
        cellphone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, message: '请输入正确的手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    const tParam = this.$route.query.t;
    if (tParam === 'init') {
      this.$message({ message: '请先完善个人信息', type: 'warning' });
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.ruleForm.birthday){
            this.ruleForm.birthday = formatDateToTimestamp(this.ruleForm.birthday);
          }
          putProfile(this.ruleForm).then((res) => {
            if (res.code === 200) {
              this.$message({ message: '更新成功', type: 'success' });
              // 修复：仅在当前路由不是 Profile 时才跳转
              if (this.$route.name !== 'Profile') { 
                this.$router.push({ name: 'Profile' });
              }
              this.$emit('refreshProfile');
            } else {
              this.$message({
                message: res.err || '更新失败',
                type: 'error'
              });
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setFormDefaults(profileData) {
      if (profileData) {
        this.ruleForm = {
          realname: profileData.realname || '',
          gender: profileData.gender || 1,
          birthday: formatTimestampToDate(profileData.birthday) || '',
          cellphone: profileData.cellphone || '',
          email: profileData.email || '',

          company: profileData.company || '',
          department: profileData.department || '',
          position: profileData.position || '', 
          title: profileData.title || '', 
          summary: profileData.summary || '',

          wxqrcode: profileData.wxqrcode || ''
        };
      }
    },
    // 二维码解析
    onFileChange(file) {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;  //回显
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            this.decodeQRCode(image);
          };
        };
        reader.readAsDataURL(file);
      }
    },
    decodeQRCode(image) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);

      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const decodedResult = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert',
      });
      console.log('decodedResult',decodedResult)

    },
    fileUpdate(item) {
      this.onFileChange(item.file)
    },
    handleAvatarSuccess(res, file) {
      console.log('handleAvatarSuccess file:',file)
      if (res.code === 200) {
        this.ruleForm.wxqrcode = res.data.url;
      } else {
        this.$message.error(res.err || '上传失败');
      }
    },
  },
  watch: {
    // 监听 profile 变化，实时更新表单默认值
    profile: {
      handler(newProfile) {
        this.setFormDefaults(newProfile);
      },
      immediate: true // 初始化时立即执行
    }
  }
};
</script>

<style></style>
